(($, Drupal) => {
  "use strict";

  // Updates the background of the subject tab in the OlexAI Marking form based on the selected subject.
  Drupal.subjectChangeBg = function (context) {
    const parentDiv = context.querySelector(
      "#edit-olexai-olexai-marking-criteria-subject"
    );
    const radioButtons = context.querySelectorAll(
      '.form-item-olexai-olexai-marking-criteria-subject input[type="radio"]'
    );
    const checkWrapper = context.querySelectorAll(
      ".form-item-olexai-olexai-marking-criteria-subject"
    );

    if (!parentDiv) return;

    const updateCheckedClass = (radio) => {
      checkWrapper.forEach((item) => item.classList.remove("checked"));
      if (radio.checked) {
        radio
          .closest(".form-item-olexai-olexai-marking-criteria-subject")
          .classList.add("checked");
      }
    };

    radioButtons.forEach((radio) => {
      if (radio.checked) {
        updateCheckedClass(radio);
      }
      radio.addEventListener("change", () => updateCheckedClass(radio));
    });
  };

  // Attach the subjectChangeBg behavior to the appropriate context.
  Drupal.behaviors.subjectChangeBg = {
    attach: function (context, settings) {
      Drupal.subjectChangeBg(context, settings);
    },
  };
})(jQuery, Drupal);
